/**
 * Media 스타일
 * @description 폭은 부모를 채우고 높이는 `aspect-ratio` 로 계산된다. radius·padding·색이
 *   없는 순수 비율 상자다. 비율은 치수가 아니라 시안이 정한 비(比)라 대응 토큰이 없다 —
 *   DS 에서 토큰을 거치지 않는 유일한 자리다.
 *
 *   `aspect-ratio` 는 가로/세로다. 시안이 `1:1.33`(세로가 김) 처럼 표기한 경우 역수로 넣는다.
 */
import { cva } from "class-variance-authority";

export const mediaStyles = cva(
  /* 슬롯이 상자를 채운다 — `next/image` 의 `fill` 도, 보통 `<img>` 도 같은 규칙으로 선다 */
  "relative w-full overflow-hidden [&>img]:size-full [&>img]:object-cover",
  {
    variants: {
      ratio: {
        square: "aspect-square",
        landscape: "aspect-[3/2]",
        portrait: "aspect-[1/1.33]",
        wide: "aspect-[1.78]",
        panorama: "aspect-[2.33]",
      },
    },
  },
);

/** 숫자가 필요한 자리(`toMediaRatio` 같은 근사 계산)를 위한 같은 표 */
export const MEDIA_RATIO_VALUE = {
  square: 1,
  landscape: 3 / 2,
  portrait: 1 / 1.33,
  wide: 1.78,
  panorama: 2.33,
} as const;
